import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfirmareRelatieService } from './confirmare-relatie.service';
import { AddConfirmareRelatieComponent } from './add-confirmare-relatie/add-confirmare-relatie.component';
import { EditConfirmareRelatieComponent } from './edit-confirmare-relatie/edit-confirmare-relatie.component';

@Component({
    selector: 'app-confirmare-relatie',
    templateUrl: './confirmare-relatie.component.html',
    styleUrls: ['./confirmare-relatie.component.scss']
})
export class ConfirmareRelatieComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: boolean | '-1' = '-1';
    publicValue: boolean | '-1' = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = this.requestService.listDTUrl;

    parameters: { key: string; value: boolean | '-1' }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: true },
        { key: 'Nu', value: false },
    ];

    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }
    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private requestService: ConfirmareRelatieService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public = this.publicValue;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Status',
                    data: 'name',
                    render: (data: any, type: any, row: any) => {
                        const bgColor = row.color || '';
                        return `<span style="background-color: ${bgColor}; color: white; border-radius: 4px; padding: 3px 10px">${data}</span>`;
                    },
                },
                {
                    title: 'Descriere',
                    data: 'description',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (row: any) => {
                        return `
                        <div class="d-flex align-center justify-content-left">
                        <button class="action-btn edit ms-1">
                            <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                        </button>
                        <button class="action-btn delete ms-1">
                            <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                        </button>
                        <button type="button" class="action-btn update_status_active ms-1 ` +
                            (row.is_active == true ? 'action-success' : 'action-danger') +
                            `">
                                <img class="btn-img" src="` +
                            (row.is_active == true
                                ? '/assets/icons/check-white.svg'
                                : '/assets/icons/close-white.svg') +
                            `" alt="update_status_active"/>
                        </button>
                        <button type="button" class="action-btn update_status_public ms-1 ` +
                            (row.is_public == true
                                ? 'action-success'
                                : 'action-danger') +
                            `">
                            <img class="btn-img" src="` +
                            (row.is_public == true
                                ? '/assets/icons/public_white.svg'
                                : '/assets/icons/public_not_white.svg') +
                            `" alt="update_status_public"/>
                        </button>
                    </div>
            `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;
                const updateStatusPublicIcon = lastTd?.querySelector(
                    '.update_status_public'
                ) as HTMLElement;

                if (editIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'dgaspc-module.settings.status-cerere.update'
                    //     )
                    // ) {
                    //     editIcon.style.display = 'none';
                    // }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'dgaspc-module.settings.status-cerere.delete'
                    //     )
                    // ) {
                    //     deleteIcon.style.display = 'none';
                    // }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteEntry(id);
                    });
                }

                if (updateStatusActiveIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'dgaspc-module.settings.status-cerere.update-status'
                    //     )
                    // ) {
                    //     updateStatusActiveIcon.style.display = 'none';
                    // }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                if (updateStatusPublicIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'dgaspc-module.settings.status-cerere.update-public'
                    //     )
                    // ) {
                    //     updateStatusPublicIcon.style.display = 'none';
                    // }
                    updateStatusPublicIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusPublic(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddConfirmareRelatieComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditConfirmareRelatieComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteEntry(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestService.deleteEntry(id).subscribe({
                    next: () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Înregistrare ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    error: (err: any) => {
                        let msg;
                        try {
                            // try to catch the message from server
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            // controll output message
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: msg,
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul înregistrării selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        console.log(id);
        this.requestService.changeStatusActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err: any) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }

    changeStatusPublic(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul înregistrării selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusPublicAction(id);
            }
        });
    }

    changeStatusPublicAction(id: number) {
        this.isLoading = true;
        this.requestService.changeStatusPublic(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusPublicAction(id);
                    }
                });
            }
        );
    }
}